import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import ChangePasswordModal from '../components/ChangePasswordModal';

const ChangePasswordModalContext = createContext(null);

export function useChangePasswordModal() {
  const ctx = useContext(ChangePasswordModalContext);
  return ctx;
}

export function ChangePasswordModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openChangePasswordModal = useCallback(() => setOpen(true), []);
  const closeChangePasswordModal = useCallback(() => setOpen(false), []);
  const value = useMemo(
    () => ({
      openChangePasswordModal,
      closeChangePasswordModal,
    }),
    [openChangePasswordModal, closeChangePasswordModal]
  );
  return (
    <ChangePasswordModalContext.Provider value={value}>
      {children}
      <ChangePasswordModal open={open} onClose={closeChangePasswordModal} />
    </ChangePasswordModalContext.Provider>
  );
}
